import Loadable from 'react-loadable';

export const Feedback = Loadable({
  loader: () => import(/* webpackChunkName: "Feedback" */ './Feedback'),
  loading: () => null,
});
